export default {
  'login.banner.title': 'Out-of-the-box back-office management system',
  'login.banner.desc': 'Common system solutions are built in',
  'login.form.title': 'Login',
  'login.form.username.placeholder': 'Please input username',
  'login.form.username.rule': 'Please input username',
  'login.form.password.placeholder': 'Please input password',
  'login.form.password.rule': 'Please input password',
  'login.form.captcha.placeholder': 'Please input captcha',
  'login.form.captcha.rule': 'Please input captcha',
  'login.form.captcha.refresh': 'Refresh captcha',
  'login.form.remember.label': 'Remember me',
  'login.form.submit': 'Login',
}
